import { ValueFormat } from '../interfaces';

// Indian number formatting: ₹4.2 Cr, ₹18.6 L, 3,41,205.
export const formatInr = (value: number | null | undefined, compact = true): string => {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  const abs = Math.abs(value);
  const sign = value < 0 ? '−' : '';
  if (compact && abs >= 1e7) return `${sign}₹${(abs / 1e7).toFixed(abs >= 1e9 ? 0 : abs >= 1e8 ? 1 : 2)} Cr`;
  if (compact && abs >= 1e5) return `${sign}₹${(abs / 1e5).toFixed(1)} L`;
  return `${sign}₹${Math.round(abs).toLocaleString('en-IN')}`;
};

export const formatValue = (value: number | null | undefined, format: ValueFormat = 'count'): string => {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  switch (format) {
    case 'inr': return formatInr(value);
    case 'percent': return `${(value * 100).toFixed(1)}%`;
    case 'days': return `${Math.round(value).toLocaleString('en-IN')} days`;
    case 'decimal': return `${value.toFixed(2)}×`;
    default: return Math.round(value).toLocaleString('en-IN');
  }
};

// Compact axis ticks: 4.2Cr, 18L, 12k.
export const formatTick = (value: number, format: ValueFormat = 'count'): string => {
  const abs = Math.abs(value);
  const prefix = format === 'inr' ? '₹' : '';
  if (format === 'percent') return `${Math.round(value * 100)}%`;
  if (format === 'decimal') return `${value}×`;
  if (abs >= 1e7) return `${prefix}${(value / 1e7).toFixed(1)}Cr`;
  if (abs >= 1e5) return `${prefix}${(value / 1e5).toFixed(0)}L`;
  if (abs >= 1e3) return `${prefix}${(value / 1e3).toFixed(0)}k`;
  return `${prefix}${value}`;
};

export const change = (current: number | null | undefined, previous: number | null | undefined): number | null =>
  current === null || current === undefined || !previous ? null : (current - previous) / previous;
